// Fish houses: bought with sand dollars, placed anywhere in the ocean, and home
// to the fish you move in from your bucket. Kinds and sizes match ocean_recipes and
// ocean_house_capacity() in supabase/migrations/20261013_sandbox.sql.

export type HouseKind = 'shell_hut' | 'coral_cottage' | 'treasure_chest';

export const HOUSES: Record<HouseKind, { name: string; capacity: number; size: number }> = {
  shell_hut: { name: 'Shell hut', capacity: 2, size: 84 },
  coral_cottage: { name: 'Coral cottage', capacity: 4, size: 112 },
  treasure_chest: { name: 'Treasure chest', capacity: 6, size: 104 },
};
/** Where the doorway is, from the house's base (fish swim in and out through it). */
export function houseDoor(kind: HouseKind): { dx: number; dy: number } {
  const s = HOUSES[kind].size;
  return kind === 'shell_hut' ? { dx: -s * 0.18, dy: -s * 0.1 } : kind === 'coral_cottage' ? { dx: 0, dy: -s * 0.14 } : { dx: 0, dy: -s * 0.46 };
}
export const isHouse = (item: string): item is HouseKind => item in HOUSES;

const INK = '#1e2633';

/** Draw a house standing on the ground at (x, groundY). */
export function drawHouse(g: CanvasRenderingContext2D, kind: HouseKind, x: number, groundY: number, t: number, ghost = false) {
  const s = HOUSES[kind].size;
  g.save();
  g.translate(x, groundY);
  if (ghost) g.globalAlpha = 0.55;
  g.lineJoin = 'round';
  g.lineCap = 'round';
  g.strokeStyle = INK;
  g.lineWidth = 3;
  if (kind === 'shell_hut') {
    // A spiral shell with a round door.
    g.fillStyle = '#ffd7c2';
    g.beginPath();
    g.moveTo(-s * 0.5, 0);
    g.bezierCurveTo(-s * 0.55, -s * 0.75, s * 0.35, -s * 1.05, s * 0.5, -s * 0.35);
    g.quadraticCurveTo(s * 0.55, 0, s * 0.3, 0);
    g.closePath(); g.fill(); g.stroke();
    g.strokeStyle = 'rgba(30,38,51,0.45)'; g.lineWidth = 2;
    for (let i = 0; i < 4; i++) { g.beginPath(); g.arc(s * 0.12, -s * 0.42, s * (0.08 + i * 0.07), Math.PI * 0.9, Math.PI * 2.1); g.stroke(); }
    g.strokeStyle = INK; g.lineWidth = 3;
    g.fillStyle = '#5a3a2a';
    g.beginPath(); g.ellipse(-s * 0.18, -s * 0.16, s * 0.13, s * 0.16, 0, Math.PI, 0); g.lineTo(-s * 0.05, 0); g.lineTo(-s * 0.31, 0); g.closePath(); g.fill(); g.stroke();
  } else if (kind === 'coral_cottage') {
    // A coral-pink cottage with a sea-green roof, windows and a chimney of bubbles.
    g.fillStyle = '#ff9fb0';
    g.beginPath(); g.roundRect(-s * 0.42, -s * 0.55, s * 0.84, s * 0.55, 6); g.fill(); g.stroke();
    g.fillStyle = '#3db8a8';
    g.beginPath(); g.moveTo(-s * 0.52, -s * 0.52); g.lineTo(0, -s * 0.95); g.lineTo(s * 0.52, -s * 0.52); g.closePath(); g.fill(); g.stroke();
    g.fillStyle = '#5a3a2a';
    g.beginPath(); g.roundRect(-s * 0.1, -s * 0.3, s * 0.2, s * 0.3, [s * 0.1, s * 0.1, 0, 0]); g.fill(); g.stroke();
    g.fillStyle = '#fff4a8';
    for (const wx of [-s * 0.28, s * 0.2]) { g.beginPath(); g.roundRect(wx, -s * 0.42, s * 0.12, s * 0.12, 3); g.fill(); g.stroke(); }
    g.fillStyle = 'rgba(255,255,255,0.7)';
    for (let i = 0; i < 3; i++) {
      const p = (t * 0.4 + i / 3) % 1;
      g.beginPath(); g.arc(s * 0.25 + Math.sin(p * 8) * 4, -s * 0.8 - p * s * 0.6, 3 + i, 0, Math.PI * 2); g.globalAlpha = (ghost ? 0.55 : 1) * (1 - p); g.fill();
    }
    g.globalAlpha = ghost ? 0.55 : 1;
  } else {
    // An open treasure chest, gold glinting.
    g.fillStyle = '#8a5a35';
    g.beginPath(); g.roundRect(-s * 0.48, -s * 0.42, s * 0.96, s * 0.42, 6); g.fill(); g.stroke();
    g.save(); g.translate(-s * 0.48, -s * 0.42); g.rotate(-0.5 - Math.sin(t * 0.8) * 0.05);
    g.beginPath(); g.roundRect(0, -s * 0.28, s * 0.96, s * 0.28, [10, 10, 2, 2]); g.fill(); g.stroke(); g.restore();
    g.fillStyle = '#ffd23d';
    g.beginPath(); g.ellipse(0, -s * 0.42, s * 0.4, s * 0.12, 0, Math.PI, 0); g.fill(); g.stroke();
    g.strokeStyle = '#4b3a2a'; g.lineWidth = 4;
    for (const bx of [-s * 0.3, s * 0.3]) { g.beginPath(); g.moveTo(bx, -s * 0.42); g.lineTo(bx, 0); g.stroke(); }
    const glint = 0.5 + 0.5 * Math.sin(t * 3);
    g.fillStyle = `rgba(255,255,255,${glint})`;
    g.beginPath(); g.arc(-s * 0.1, -s * 0.48, 3, 0, Math.PI * 2); g.fill();
  }
  g.restore();
}
